export default [
  'token',
  '/informante/associacao',
  '/indicador/dashboard',
  '/informante/associacaocusto',
  '/levantamentocusto/dashboard',
  '/seriehistoricageral',
  '/seriehistorica',
  '/cadeia/publica',
  '/indicadorgrupo/publica',
  '/indicadorfinal/publica',
  '/estado/publica',
  '/regiao/publica',
  '/cidade/publica',
  '/safra/publica',
  '/seriehistorica/publica',
  '/tipolocalidade/publica',
  '/seriehistorica/publica/dados',
  '/seriehistorica/dados'
]
